// Service worker registration. With autoUpdate + skipWaiting +
// clientsClaim configured in vite.config.js, the new SW activates on
// the next page load without user interaction. We still surface a
// toast on detection so the broker knows the version flipped.
//
// 2026-05-23 fix: previous setup only checked for SW updates at page
// load. Brokers leaving V2 open for hours past a deploy stayed on the
// old bundle until they hard-refreshed (symptom: stale rendering,
// "TRACON locks up", LPR sheet using pre-fix coords against a
// post-fix backend). Now we poll for SW updates every 5 minutes
// while the page is foregrounded — when a new bundle ships,
// onNeedRefresh fires and the toast + reload kick in automatically.

import { registerSW } from 'virtual:pwa-register';
import { toast } from '@/components/ui/toaster.jsx';

const SW_UPDATE_POLL_MS = 60 * 1000;

export function setupPWA() {
  if (import.meta.env.DEV) return;
  registerSW({
    immediate: true,
    onNeedRefresh() {
      toast('Updating TRACON…', { duration: 200 });
      setTimeout(() => window.location.reload(), 100);
    },
    onOfflineReady() {
      // Silent — broker doesn't need a "ready offline" notification.
    },
    onRegistered(swRegistration) {
      if (!swRegistration) return;
      // Foreground-only update polling — calling registration.update()
      // when the tab is hidden is a wasted network round trip and the
      // browser will throttle it anyway.
      const tick = () => {
        if (document.visibilityState === 'visible') {
          swRegistration.update().catch((err) => {
            console.warn('[PWA] SW update check failed:', err);
          });
        }
      };
      setInterval(tick, SW_UPDATE_POLL_MS);
      // Also re-check when the tab regains focus — if the broker
      // backgrounded for hours, the periodic timer may have been
      // suspended by the browser.
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') tick();
      });
    },
    onRegisterError(err) {
      console.warn('[PWA] SW registration failed:', err);
    },
  });
}
